import React from 'react';
import { Skeleton } from 'antd';
import './style.scss';

interface IProps {
  numberOfBlocks?: number;
}

const NUMBER = 1;
const NUMBER_OF_BLOCKS = [NUMBER, NUMBER, NUMBER];

export class SkeletonBenefitsItems extends React.Component<IProps> {
  render(): React.ReactNode {
    const { numberOfBlocks } = this.props;
    const blocks = numberOfBlocks ? Array(numberOfBlocks).fill(NUMBER) : NUMBER_OF_BLOCKS;
    
    return (
      <div className="skeleton-benefits-items">
        {blocks.map((item, index) => (
          <div key={`${index}-${item}`} className="skeleton-benefits-items__wrapper">
            <Skeleton
              className="skeleton-benefits-items__img-skeleton"
              active
              title={false}
              paragraph={{ rows: 1 }}
            />
            <Skeleton
              className="skeleton-benefits-items__text-skeleton"
              active
              title={false}
              paragraph={{ rows: 2 }}
            />
            <Skeleton
              className="skeleton-benefits-items__text-skeleton"
              active
              title={false}
              paragraph={{ rows: 3 }}
            />
          </div>
        ))}
      </div>
    );
  }
}
